export const COMMENT_HOOK = "COMMENT_HOOK";